import { render, staticRenderFns } from "./tenderManagement.vue?vue&type=template&id=4afe2074&"
import script from "./tenderManagement.vue?vue&type=script&lang=js&"
export * from "./tenderManagement.vue?vue&type=script&lang=js&"
import style0 from "./tenderManagement.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports